import { RateResponseType, RateType } from 'V2/Types/Rate';

export const transformRateResponse = (response: RateResponseType): RateType => {
  return {
    identifier: response?.identifier,
    monthlyPremium: response?.monthlyPremium,
    paymentDetails: response?.paymentDetails?.attributes,
    pdfDownloadURL: response?.pdfDownloadURL,
    totalPremium: response?.totalPremium,
    underwritingPassed: response?.underwritingPassed,
  };
};
